import { WORKFLOWS } from '../data/workflowRegistry';
import { Workflow } from '../types/workflow';

export function listWorkflows(): Workflow[] {
  return WORKFLOWS;
}

export function getWorkflow(id: string): Workflow | undefined {
  return WORKFLOWS.find(w => w.id === id);
}
